import { render } from "./NoticePopups.vue?vue&type=template&id=6f0ecb6e"
import script from "./NoticePopups.vue?vue&type=script&lang=js"
export * from "./NoticePopups.vue?vue&type=script&lang=js"

import "./NoticePopups.vue?vue&type=style&index=0&id=6f0ecb6e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__